module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/顶部图.8f190492.png";